<template>
  <div>
    <p class="message colorGrey mb5 notranslate">{{locale.reservation_message_touchmove}}</p>
    <div ref="map" class="mapFrame">
      <div class="seatMap">
        <div class="ground">
          <!-- seat map -->
          <div class="seatsBg">
            <div id="seats" class="seats" ref="seat">
              <SeatRect v-for="seat in seats"
                :key="seat.seatId"
                :data-place="seat.placeId"
                :data-seat="seat.seatId"
                :data-active="!seat.disabled && activeTarget.includes(seat.seatId)"
                :data-disabled="seat.disabled"
                :w="seat.w"
                :h="seat.h"
                :x="seat.x"
                :y="seat.y">
                <div class="filler"
                  :class="{disabled: seat.disabled}"
                  @click="active(seat)">
                  <span v-if="info.showPlaceName" class="place" :style="{backgroundColor: seat.color}">
                    {{seat.placeName[lang]}}
                  </span>
                  <span v-if="info.showSeatName" class="seat">{{seat.name[lang]}}</span>
                </div>
              </SeatRect>
            </div>
          </div>
          <!-- //seat map -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeatRect from '@/components/Reservation/SeatRect.vue'

export default {
  name: 'SeatMap',
  props: [
    'locale',
    'lang',
    'seats',
    'objects',
    'info',
    'activeTarget',
    'count'
  ],
  components: {
    SeatRect
  },
  methods: {
    active (seat) {
      const disabled = seat.disabled
      if (!disabled) {
        this.$emit('activeSeat', {
          placeId: seat.placeId,
          placeName: seat.placeName,
          seatId: seat.seatId,
          seatName: seat.name
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mapFrame {
  overflow: auto;
}
.ground:before {
  // content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.message {
  font-size: 14px;
  &:before {
    content: "";
    display: inline-block;
    position: relative;
    top: 2px;
    width: 20px;
    height: 16px;
    margin-right: 4px;
    background: url('~@/assets/img/ico_touchmove_horizontal.png') 0 50% / contain no-repeat;
    opacity: 0.5;
  }
}
</style>
